import PrivilegedUsers from './screens/PrivilegedUsers';
import { PrivilegedAccountsContextProvider } from './context/PrivilegedAccountsContext';

export const PrivilegedUsersWrapper = () => {
    return (
        <PrivilegedAccountsContextProvider>
            <PrivilegedUsers />
        </PrivilegedAccountsContextProvider>
    );
};
